import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

/**
 * Google Ads 跟踪代码组件
 * 可在App.js中引入，确保在所有页面都加载
 */
const GoogleAdsTag = () => {
  useEffect(() => {
    // 初始化Google Ads代码
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'AW-16953009461');
  }, []);

  return (
    <Helmet>
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16953009461"></script>
    </Helmet>
  );
};

/**
 * 跟踪特定的转化事件
 * @param {string} conversionId - 转化ID
 * @param {string} conversionLabel - 转化标签
 * @param {Object} additionalParams - 额外参数
 */
export const trackConversion = (conversionId, conversionLabel, additionalParams = {}) => {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': `${conversionId}/${conversionLabel}`,
      ...additionalParams
    });
  }
};

export default GoogleAdsTag;